module.exports = __webpack_public_path__ + "static/media/_MIC2293.thumbnail.9ec47248.png";